import React from 'react'

const Vimeo = ({node}) => {
    if(!node.url) {
        return (<div></div>)
    }
    const url = node.url.replace("https://vimeo.com/", "https://player.vimeo.com/video/")

    return (
        <iframe 
            title="Vimeo video" 
            src={url} 
            width="640" 
            height="360" 
            frameborder="0" 
            allowfullscreen>
        </iframe>
    )
}

export default Vimeo